import { useMemo } from 'react';

import { useGetSubscriptionPricingQuery } from 'src/features/pricing/pricing.slice';

type PricingHookResult = {
  price: string;
  symbol: string;
};

export const usePricing = (showYearly?: boolean): PricingHookResult => {
  const { data: response } = useGetSubscriptionPricingQuery(false);

  const { price, symbol } = useMemo(() => {
    if (!response?.data) {
      return { price: '', symbol: '' };
    }

    const { monthlyPlan, yearlyPlan } = response.data;
    const plan = showYearly ? yearlyPlan : monthlyPlan;

    return {
      price: plan.price.toFixed(Number.isInteger(plan.price) ? 0 : 2),
      symbol: plan.symbol,
    };
  }, [response, showYearly]);

  return { price, symbol };
};
